<!--
    描述： 县区统计
    创建时间： 2022-03-21 11:22:49
    作者： Wang Shuai
    邮箱： 591372242@qq.com
-->
<template>
	<div class="filter-layout">
		<div class="filter-box pdt10">
			<template v-if="filterShow">
				<el-form ref="searchForm"
						 size="small"
						 label-width="100px">
					<el-row>
						<template v-if="curType != 3">
							<el-col :span="6">
								<el-form-item label="选择年份:">
									<el-date-picker v-model="selectYear"
													type="year"
													placeholder="选择年"
													size="small"
													value-format="yyyy"
													format="yyyy年"
													:clearable="curType == 1 ? true : false">
									</el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="6"
									:offset="3">
								<el-form-item label="片区：">
									<div class="time-box">
										<span :key="item.id"
											  class="text-overflow"
											  v-for="item in areaList"
											  :class="{ 'active-time': selectArea == item.value }"
											  @click="searchClick(item)">
											{{ item.sname }}
										</span>
									</div>
								</el-form-item>
							</el-col>
						</template>
						<template v-else>
							<el-col :span="6">
								<el-form-item label="时间维度">
									<div class="custom-box">
										<span :key="item.id"
											  class="text-overflow"
											  v-for="(item, index) in timeOptions"
											  :class="{ 'active-span': activeTimeBtn === index }"
											  @click="changeDateType(item, index)">
											{{ item.label }}
										</span>
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="6"
									:offset="3">
								<!-- 按月份 -->
								<template v-if="activeTimeBtn === 0">
									<el-form-item label="选择月份"
												  prop="time">
										<el-date-picker v-model="timeObj.time"
														type="monthrange"
														@change="monthChange($event, 'month')"
														range-separator="~"
														start-placeholder="开始月份"
														end-placeholder="结束月份"
														value-format="yyyy-MM">
										</el-date-picker>
									</el-form-item>
								</template>
								<!-- 按季度 -->
								<template v-if="activeTimeBtn === 1">
									<el-form-item label="选择季度">
										<div class="flex">
											<el-select v-model="timeObj.startDate"
													   placeholder="开始季度"
													   clearable
													   @change="quarterChange($event, 'start')">
												<el-option v-for="item in quarterList"
														   :key="'start' + item.id"
														   :label="item.year + '年' + item.quarter + '季度'"
														   :value="item.quarterStartTime">
												</el-option>
											</el-select>
											<span class="ml5 mr5">~</span>
											<el-select v-model="timeObj.endDate"
													   placeholder="结束季度"
													   clearable
													   @change="quarterChange($event, 'end')">
												<el-option v-for="item in quarterList"
														   :key="'end' + item.id"
														   :label="item.year + '年' + item.quarter + '季度'"
														   :value="item.quarterEndTime">
												</el-option>
											</el-select>
										</div>
									</el-form-item>
								</template>
								<!-- 按年份 -->
								<template v-if="activeTimeBtn === 2">
									<el-form-item label="选择年份">
										<div class="flex">
											<el-date-picker v-model="timeObj.startDate"
															type="year"
															placeholder="开始年份"
															value-format="yyyy"
															@change="yearChange($event, 'start')">
											</el-date-picker>
											<span class="ml5 mr5">~</span>
											<el-date-picker v-model="timeObj.endDate"
															type="year"
															placeholder="结束年份"
															value-format="yyyy"
															@change="yearChange($event, 'end')">
											</el-date-picker>
										</div>
									</el-form-item>
								</template>
							</el-col>
						</template>
						<el-col :span="6"
								:offset="3"
								class="text-right">
							<el-form-item>
								<el-button size="small"
										   icon="el-icon-search"
										   type="primary"
										   @click="getTableData">查询</el-button>
								<el-button size="small"
										   icon="el-icon-refresh"
										   @click="doRefresh">重置</el-button>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</template>

			<!-- 筛选折叠按钮 -->
			<div class="control-btn"
				 @click="filterShow = !filterShow">
				<span v-if="filterShow">
					点击收起
					<svg-icon icon-class="pack-up"
							  class="c-icon ml5"></svg-icon>
				</span>
				<span v-else>筛选
					<svg-icon icon-class="pack-down"
							  class="c-icon ml5"></svg-icon>
				</span>
			</div>
		</div>

		<div class="filter-content overflow-hidden">
			<h2 v-if="curType == 1"
				class="content-header">东部新中心建设项目片区产值统计报表</h2>
			<h2 v-else
				class="content-header">
				东部新中心建设项目{{curType == 2 ? selectAreaName : ''}}产值统计图
				<el-tooltip placement="bottom-start"
							effect="light"
							style="width: 20px; height: 20px; vertical-align: text-top;">
					<div slot="content">
						<p>数据统计说明：默认展示本年度月份数据统计，当选择其他年月</p>
						<p class="mt5">数据时，则展示其他年度数据统计。</p>
						<p class="mt10">本年度项目：有计划开竣工时间，且时间范围在本年度的，无实</p>
						<p class="mt5">际竣工时间都纳入本年度项目统计。</p>
						<p class="mt5">有计划开竣工时间，且实际竣工时间为本年度的，本年纳入统</p>
						<p class="mt5">计，第二年不统计。</p>
						</p>
					</div>
					<svg-icon class="ml5"
							  icon-class="wenhao"></svg-icon>
				</el-tooltip>
			</h2>

			<div class="content-subtitle">
				<div class="left">
					<el-radio-group v-model="curType"
									@change="changeChartType"
									size="mini">
						<el-radio-button :label="1">表格</el-radio-button>
						<el-radio-button :label="2">柱状图/折线图</el-radio-button>
						<el-radio-button :label="3">饼状图</el-radio-button>
					</el-radio-group>
					<span v-if="curType != 3"
						  class="ml20 custom-text">统计时间： {{ selectYear + ' 年' }}</span>
					<span v-else
						  class="ml20 custom-text">统计时间： {{ rangeTime }}</span>
				</div>

				<div class="right">
					<span class="custom-text">单位：</span>
					<el-radio-group v-model="isMillion"
									size="mini"
									class="mr10"
									@change="getTableData">
						<el-radio-button label="1">元</el-radio-button>
						<el-radio-button label="2">万元</el-radio-button>
						<el-radio-button v-if="curType == 1"
										 label="3">亿元</el-radio-button>
					</el-radio-group>
					<template v-if="curType == 1">
						<el-button type="primary"
								   size="mini"
								   icon="el-icon-menu"
								   @click="doFilter">列过滤</el-button>
						<el-button @click="exportExcelMethod()"
								   size="mini">导出Excel</el-button>
					</template>
					<el-button v-else
							   @click="exportChart"
							   icon="el-icon-download"
							   size="mini">导出</el-button>
				</div>
			</div>

			<div v-if="curType == 1"
				 class="content-table">
				<vxe-table :data="tableObj.tableData"
						   align="center"
						   header-align="center"
						   height="auto"
						   auto-resize
						   border
						   ref="countyTable"
						   :loading="tableObj.loading"
						   highlight-current-row
						   highlight-hover-row
						   :row-class-name="customClass"
						   show-overflow="tooltip"
						   show-header-overflow="tooltip">
					<vxe-column field="sort"
								title="序号"
								width="70"></vxe-column>
					<vxe-column field="monName"
								title="年/月"
								width="150"></vxe-column>
					<vxe-column field="areaName"
								title="片区"
								width="150"></vxe-column>
					<!-- <vxe-column field="packName"
								title="标段名称"
								width="150"></vxe-column> -->
					<vxe-colgroup title="计划"
								  header-class-name="custom-table-height">
						<vxe-column field="planCompletedOutputValue"
									title="计划完成产值"
									min-width="120"
									align="right"
									header-align="center"
									header-class-name="custom-table-height">
							<template #default="{ row }">
								{{ setValue(row.planCompletedOutputValue) }}
							</template>
						</vxe-column>
						<vxe-column field="planProgressPayment"
									title="计划进度款"
									min-width="120"
									align="right"
									header-align="center"
									header-class-name="custom-table-height">
							<template #default="{ row }">
								{{ setValue(row.planProgressPayment) }}
							</template>
						</vxe-column>
					</vxe-colgroup>
					<vxe-colgroup title="申报"
								  header-class-name="custom-table-height">
						<vxe-column field="declareCompletedOutputValue"
									title="申报完成产值"
									min-width="120"
									align="right"
									header-align="center"
									show-overflow="tooltip"
									header-class-name="custom-table-height">
							<template #default="{ row }">
								{{ setValue(row.declareCompletedOutputValue) }}
							</template>
						</vxe-column>
						<vxe-column field="declareProgressPayment"
									title="申报进度款"
									min-width="120"
									align="right"
									header-align="center"
									header-class-name="custom-table-height">
							<template #default="{ row }">
								{{ setValue(row.declareProgressPayment) }}
							</template>
						</vxe-column>
					</vxe-colgroup>
					<vxe-colgroup title="审核"
								  header-class-name="custom-table-height">
						<vxe-column field="examineCompletedOutputValue"
									title="审核完成产值"
									min-width="120"
									align="right"
									header-align="center"
									header-class-name="custom-table-height">
							<template #default="{ row }">
								{{ setValue(row.examineCompletedOutputValue) }}
							</template>
						</vxe-column>
						<vxe-column field="examineProgressPayment"
									title="审核应付进度款"
									min-width="120"
									align="right"
									header-align="center"
									header-class-name="custom-table-height">
							<template #default="{ row }">
								{{ setValue(row.examineProgressPayment) }}
							</template>
						</vxe-column>
					</vxe-colgroup>
					<vxe-table-column field="actualPayment"
									  title="实际付款"
									  min-width="120"
									  align="right"
									  header-align="center">
						<template #default="{ row }">
							{{ setValue(row.actualPayment) }}
						</template>
					</vxe-table-column>
				</vxe-table>
			</div>

			<!-- 柱状图/折线图 -->
			<div v-else-if="curType == 2"
				 class="content-table">
				<LineChart ref="line_chart"
						   :apiParams="apiParams" />
			</div>

			<!-- 饼状图 -->
			<div v-else-if="curType == 3"
				 class="content-table">
				<PieChart ref="pie_chart"
						  :apiParams="apiParams" />
			</div>
		</div>

		<!-- 列过滤 -->
		<ColumnFilter ref="ColumnFilter"
					  v-if="showFilter"
					  :filterColumns="filterColumns"
					  @onFilter="onFilter"></ColumnFilter>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import {
	getCountyData,
	getProjectPieQuarter,
} from 'api/FormManager/FormManager'
import { getContainerParams } from '@/api/home/homeIndex'
import TextTooltip from '@/views/Common/TextTooltip'
import ColumnFilter from '@/views/Common/ColumnFilter'
import { exportExcel } from 'utils/tools'
import LineChart from './components/LineChart'
import PieChart from './components/PieChart'

export default {
	components: { TextTooltip, ColumnFilter, LineChart, PieChart },
	data() {
		return {
			filterShow: true,
			selectYear: '',
			selectArea: [],
			selectAreaName: '片区',
			area: [],
			curType: 1,
			isMillion: '2',
			tableObj: {
				tableData: [],
				loading: false,
			},
			showFilter: false, //列过滤弹窗显隐
			// 列过滤内容
			filterColumns: [
				{
					title: '',
					checkAll: false,
					columns: [],
				},
			],
			// 折线图/柱状图、饼状图的查询参数
			apiParams: {},
			// 饼状图的查询
			selectDateType: 3, // 时间维度
			activeTimeBtn: 2, // 选中的时间维度
			timeObj: {
				time: [],
				startDate: '',
				endDate: '',
			},
			rangeTime: '',
			quarterList: [], // 季度数据
			currentQuarter: '', // 当前季度
		}
	},
	created() {
		this.tableObj.loading = true
		setTimeout(() => {
			this.selectYear = new Date().getFullYear() + ''
			this.selectArea = this.projectDict.xmgsqy
				.map((x) => x.value)
				.join(',')

			this.getTableData()
		}, 100)
		// 列过滤获取所有列
		setTimeout(() => {
			if (this.$refs.countyTable) {
				let tableColumn = this.$refs.countyTable.getTableColumn()
				tableColumn.fullColumn.shift()
				this.filterColumns[0].columns = tableColumn.fullColumn
			}
		}, 1500)
	},
	methods: {
		// 点击列过滤
		doFilter() {
			this.showFilter = true
			setTimeout(() => {
				this.$refs.ColumnFilter.dialogObj.visible = true
			}, 200)
		},

		// 确认列过滤
		onFilter(arr) {
			this.tableObj.loading = true
			if (this.$refs.countyTable) {
				// 确定赋值
				this.$set(this, 'filterColumns', arr)
				this.$refs.countyTable.refreshColumn()
				this.tableObj.loading = false
				return
			}
			this.tableObj.loading = false
		},

		// 获取数据
		getTableData() {
			let params = {
				area: this.selectArea,
				selectYear: this.selectYear,
				isMillion: this.isMillion,
			}
			switch (this.curType) {
				case 1:
					this._getCountyData(params)
					break
				case 2:
					this.apiParams = {
						year: this.selectYear,
						unit:
							this.isMillion == '1'
								? '0'
								: this.isMillion == '2'
								? '1'
								: '',
						isNorth: this.selectArea,
					}
					break
				case 3:
					this.apiParams = {
						selectDateType: this.selectDateType,
						unit:
							this.isMillion == '1'
								? '0'
								: this.isMillion == '2'
								? '1'
								: '',
						startDate: this.timeObj.startDate,
						endDate: this.timeObj.endDate,
					}
					break
				default:
					break
			}
		},

		// 获取表格数据
		_getCountyData(params) {
			this.tableObj.loading = true
			getCountyData(params)
				.then((res) => {
					this.tableObj.loading = false
					this.tableObj.tableData = res.data
				})
				.catch((err) => {
					this.tableObj.loading = false
				})
		},

		// 处理值（根据单位变化）
		setValue(value) {
			// 后台处理
			return value
		},

		// 片区点击
		searchClick(data) {
			this.selectArea = data.value
			this.selectAreaName =
				this.selectArea.indexOf(',') > -1 ? '片区' : data.sname
			this.getTableData()
		},

		// 导出excel
		exportExcelMethod() {
			let tableData = this.tableObj.tableData
			let params = {
				selectYear: this.selectYear, //统计时间
				excelData: tableData, //导出数据集合
				isMillion: this.isMillion,
			}
			let baseUrl = '/auditPlanValue/exportExcel'
			let url = process.env.VUE_APP_BASE_URL + baseUrl
			let fileName = ''
			exportExcel(url, params, fileName)
		},

		// 重置
		doRefresh() {
			this.selectYear = new Date().getFullYear() + ''
			this.selectArea = this.projectDict.xmgsqy
				.map((x) => x.value)
				.join(',')
			this.isMillion = '2'

			if (this.curType == 3) {
				this._getContainerParams()
				this._getProjectPieQuarter()
				this.selectDateType = 3 // 时间维度
				this.activeTimeBtn = 2 // 选中的时间维度
			}
			this.selectAreaName = '片区'
			setTimeout(() => {
				this.getTableData()
			}, 200)
		},

		// 切换图表类型
		changeChartType() {
			this.doRefresh()
		},

		// 导出图表png
		exportChart() {
			switch (this.curType) {
				case 2:
					let str = `东部新中心建设项目${this.selectAreaName}产值统计图`
					this.$refs.line_chart.download(str)
					break
				case 3:
					this.$refs.pie_chart.download()
				default:
					break
			}
		},

		// 获取当前时间(后台)
		_getContainerParams() {
			getContainerParams({}).then((res) => {
				let now = res.data.currentDate
				let start = this.$utils.getWhatMonth(now, 0, 'first')
				let end = this.$utils.getWhatMonth(now, 0, 'last')
				start = this.$utils.toDateString(start, 'yyyy')
				end = this.$utils.toDateString(end, 'yyyy')
				this.timeObj.startDate = start
				this.timeObj.endDate = end
				this.timeObj.time = [start, end]
				this.rangeTime = start + '年 至 ' + end + '年'
			})
		},

		// 查询季度
		_getProjectPieQuarter() {
			getProjectPieQuarter({}).then((res) => {
				this.quarterList = res.data
				// 当前季度
				const obj = res.data.find((item) => item.isCurrent == 1)
				this.currentQuarter = obj
					? [obj.quarterStartTime, obj.quarterEndTime]
					: []
			})
		},

		// 切换时间维度
		changeDateType(item, index) {
			this.activeTimeBtn = index
			this.selectDateType = item.value

			const year = new Date().getFullYear() + ''
			const month = year + '-' + (new Date().getMonth() + 1)
			switch (index) {
				case 0:
					this.timeObj = {
						startDate: month,
						endDate: month,
						time: [month, month],
					}
					break
				case 1:
					this.timeObj = {
						startDate:
							this.currentQuarter.length > 0
								? this.currentQuarter[0]
								: '',
						endDate:
							this.currentQuarter.length > 1
								? this.currentQuarter[1]
								: '',
						time: this.currentQuarter,
					}
					break
				case 2:
					this.timeObj = {
						startDate: year,
						endDate: year,
						time: [year, year],
					}
					break
				default:
					break
			}
			this.getTableData()
		},

		// 月份选择change
		monthChange(data, type) {
			this.timeObj.startDate = data?.[0] || ''
			this.timeObj.endDate = data?.[1] || ''
			if (data && data.length > 0) {
				this.rangeTime = data[0] + ' 至 ' + data[1]
			} else {
				this.rangeTime = ''
			}
		},

		// 季度选择change
		quarterChange(data, type) {
			if (data == '') {
				return
			}
			if (type == 'start') {
				let endTime = this.timeObj.endDate
				let handlerData = this.quarterList.find(
					(x) => x.quarterStartTime == data
				)
				if (endTime != '') {
					let handlerEndData = this.quarterList.find(
						(x) => x.quarterEndTime == endTime
					)
					if (handlerData.id > handlerEndData.id) {
						this.timeObj.startDate = ''
						this.$message.error('开始季度不能超过结束季度！')
					}
				}
				return
			}
			let startTime = this.timeObj.startDate
			let handlerData = this.quarterList.find(
				(x) => x.quarterEndTime == data
			)
			if (startTime != '') {
				let handlerEndData = this.quarterList.find(
					(x) => x.quarterStartTime == startTime
				)
				if (handlerData.id < handlerEndData.id) {
					this.timeObj.endDate = ''
					this.$message.error('结束季度不能小于开始季度！')
				}
			}
		},

		// 年份选择change
		yearChange(data, type) {
			if (type == 'start') {
				let endTime = this.timeObj.endDate || 0
				if (
					parseInt(data) > parseInt(endTime) &&
					parseInt(endTime) != 0
				) {
					this.timeObj.startDate = ''
					this.$message.error('开始时间不能超过结束时间！')
				}
				return
			}
			let startTime = this.timeObj.startDate || 0
			if (parseInt(data) < parseInt(startTime)) {
				this.timeObj.endDate = ''
				this.$message.error('结束时间不能小于开始时间！')
			}
		},

		// 自定义行样式
		customClass({ row, rowIndex }) {
			if (rowIndex === 0) {
				return 'custom-total'
			}
			if (row.sort == '小计') {
				return 'custom-sTotal'
			}
		},
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),

		unitName() {
			return this.isMillion === '2' ? '(万元)' : '(元)'
		},

		areaList() {
			let all = this.projectDict.xmgsqy.map((x) => x.value)
			all = all.join(',')
			let obj = {
				sname: '全部',
				value: all,
			}
			let arr = this.$utils.clone(this.projectDict.xmgsqy, true)
			arr.unshift(obj)
			return arr
		},
		// 时间维度
		timeOptions() {
			let arr = [
				{
					label: '按月份',
					value: 1,
				},
				{
					label: '按季度',
					value: 2,
				},
				{
					label: '按年份',
					value: 3,
				},
			]
			return arr
		},
	},
	watch: {
		timeObj: {
			handler(newVal, oldVal) {
				let text1 = ''
				let text2 = ''
				switch (this.activeTimeBtn) {
					case 0:
					case 2:
						const str =
							this.activeTimeBtn === 0
								? '月'
								: this.activeTimeBtn === 2
								? '年'
								: ''
						text1 = !!newVal.startDate ? newVal.startDate + str : ''
						text2 = !!newVal.endDate ? newVal.endDate + str : ''
						break
					case 1:
						let start = this.quarterList.find(
							(x) => x.quarterStartTime == newVal.startDate
						)
						let end = this.quarterList.find(
							(x) => x.quarterEndTime == newVal.endDate
						)
						text1 =
							newVal.startDate && start
								? start.year + '年' + start.quarter + '季度'
								: ''
						text2 =
							newVal.endDate && end
								? end.year + '年' + end.quarter + '季度'
								: ''
						break
					default:
						break
				}
				if (!!text1 || !!text2) {
					this.rangeTime = text1 + ' 至 ' + text2
				} else {
					this.rangeTime = ''
				}
			},
			deep: true,
		},
	},
}
</script>

<style lang="less" scoped>
.filter-row {
	display: flex;
	align-items: center;
	height: 44px;
	font-size: 14px;

	/deep/ .el-checkbox {
		margin-right: 20px;
	}
}

.content-header {
	line-height: 60px;
	text-align: center;
	padding-top: 15px;
}

.content-subtitle {
	display: flex;
	height: 45px;
	justify-content: space-between;
	align-items: center;
}

.content-table {
	height: calc(~'100% - 75px - 45px');
}
.line-wrap {
	height: calc(~'100% - 75px - 45px - 10px');
}
.pie-wrap {
	height: calc(~'100% - 75px - 45px - 10px');
}

.custom-text {
	font-size: 14px !important;
}

.time-box {
	display: flex;
	text-align: center;
	font-size: 12px;
	span + span {
		margin-left: 10px !important;
	}
	.active-time {
		background-color: #2cbdfc !important;
		color: #fff !important;
	}
	* {
		height: 30px !important;
		line-height: 30px !important;
		background-color: #f2f2f2;
		color: #868686;
		cursor: pointer;
		flex: 1;
	}
}

.custom-box {
	display: flex;
	span:hover {
		background-color: #2cbdfc;
		color: #fff;
	}
}
.custom-box > * {
	flex: 1;
	text-align: center;
	height: 28px !important;
	line-height: 28px !important;
	font-size: 12px;
	border: 1px solid #eee;
	background-color: #fff;
	color: #868686;
	cursor: pointer;
}
.active-span {
	background-color: #2cbdfc !important;
	color: #fff !important;
}
</style>
